export const LongArrowRightIcon = ({ strokeColor = "#1A0638", width = "50", height = "10" }) => {
	return (
		<svg width={width} height={height} viewBox="0 0 50 10" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M0.820312 5.07406H49.3191M49.3191 5.07406L45.9647 9.14812M49.3191 5.07406L45.9647 1"
				stroke={strokeColor}
				strokeWidth="1.09589"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
